import axios from 'axios';
import { API_BASE_URL } from '../constants/api';
import { ACCESS_TOKEN } from '../constants/auth';

const WaterService = {
  async getWaterData(page = 0, limit = 10) {
    const token = localStorage.getItem(ACCESS_TOKEN);
    const response = await axios.get(`${API_BASE_URL}/api/water/get/desc`, {
      params: { page, limit },
      headers: {
        'accept': 'application/hal+json',
        'Authorization': `Bearer ${token}`,
      },
    });
    const { list, hasMore, pages } = response.data;
    return { list, hasMore, pages };
  },

  async getLastWaterData() {
    const token = localStorage.getItem(ACCESS_TOKEN);
    const response = await fetch(`${API_BASE_URL}/api/water/get/last`, {
      method: 'GET',
      headers: {
        'accept': 'application/hal+json',
        'Authorization': `Bearer ${token}`,
      },
    });
    if (!response.ok) throw new Error('Failed to fetch last water data');
    return await response.json();
  },
};

export default WaterService; 